import { render, staticRenderFns } from "./ChildPublic.vue?vue&type=template&id=77b8ae03&scoped=true&"
import script from "./ChildPublic.vue?vue&type=script&lang=js&"
export * from "./ChildPublic.vue?vue&type=script&lang=js&"
import style0 from "./ChildPublic.vue?vue&type=style&index=0&id=77b8ae03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b8ae03",
  null
  
)

export default component.exports